import { createFileRoute } from '@tanstack/react-router'

import { SalesBookOnboardingScreen } from './-components/book-onboarding-screen.tsx'

export const Route = createFileRoute('/sales/book-onboarding')({
  component: SalesBookOnboardingScreen
})
